export default __webpack_public_path__ + "static/media/swapIcon.7583d951.svg";